import { Injectable } from '@angular/core';
import { OutreachTemplatesService } from '@techspert-io/outreachTemplates';
import { forkJoin, map, Observable, shareReplay } from 'rxjs';
import {
  CampaignEmailTemplateTypeMap,
  IOutreachEmailTemplate,
} from '../models/outreach-email.models';

@Injectable({
  providedIn: 'root',
})
export class OutreachEmailTemplatesService {
  private templatesCache: Observable<IOutreachEmailTemplate[]>;

  constructor(private outreachTemplatesService: OutreachTemplatesService) {}

  getTemplates(): Observable<IOutreachEmailTemplate[]> {
    if (!this.templatesCache) {
      this.templatesCache = forkJoin({
        templates: this.outreachTemplatesService.getAll(),
        tags: this.outreachTemplatesService.getAllTags(),
      }).pipe(
        map(({ templates, tags }) => {
          const tagNameDictionary = Object.fromEntries(
            tags.map(({ email_template_tag_id, name }) => [
              email_template_tag_id,
              name,
            ])
          );

          return templates.map((t) => ({
            templateId: t.templateId,
            name: t.title,
            favorite: t.favorite,
            suggested: t.suggested,
            templateType: CampaignEmailTemplateTypeMap.connect,
            templateContent: {
              content: t.content,
              subject: t.subject,
              preheader: t.preheader,
            },
            tags: t.tags
              .map((tag) => tagNameDictionary[tag])
              .filter(Boolean)
              .sort(),
          }));
        }),
        shareReplay({ bufferSize: 1, refCount: true })
      );
    }
    return this.templatesCache;
  }
}
